import { helper } from '@ember/component/helper';

export default helper(function jsonStringify([value, space]) {
  return JSON.stringify(value, null, space || 2);
});
